import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@ami/react/core';
import {
  Permissions,
  dealerUserService,
} from '../../../dealer-users/dealerUserService';
import { DealerUserFilter } from '../../../dealer-users/dealerUserFilter';
import { makeValidable } from '@ami/react/core';
import { Spinner } from '@ami/react/core';
import { FormDropdown } from '@ami/react/core';
import { DealerBranch } from '../../../dealer-branches/dealerBranch';
import AuthorizedDealerBranchSettingCard from '../../../dealer-users/components/authorization/AuthorizedDealerBranchSettingCard';
import { DealerBranchSetting } from '../../../dealer-users/dealerUserService';

const ExistingUserFormData = ({
  dealerUsers,
  permissions,
  selectedDealerUserId,
  dealerUserChanged,
  dealerBranchSetting,
  onDealerBranchSettingChange,
}) => {
  return (
    <Fragment>
      <FormDropdown
        label="Existing User to Authorize"
        items={dealerUsers}
        placeholder="Select a dealer user..."
        selectedId={selectedDealerUserId}
        onChange={dealerUserChanged}
        required
      />
      <br />
      <AuthorizedDealerBranchSettingCard
        dealerBranchSetting={dealerBranchSetting}
        permissions={permissions}
        dealerBranchSettingChange={onDealerBranchSettingChange}
        showRetiredBadge={false}
      />
    </Fragment>
  );
};

const ValidableExistingUserFormData = makeValidable(ExistingUserFormData);

export default class ReviewQuoteInformationComponentExistingUser extends React.Component {
  constructor(props) {
    super(props);
    this.validableRef = React.createRef();
    this.save = this.save.bind(this);
    this.state = {
      dealerUsers: [],
      permissions: new Permissions(),
      submitting: false,
      showValidations: false,
      hasBeenLoaded: false,
      selectedDealerUserId: null,
      dealerBranchSetting: new DealerBranchSetting(
        props.dealerBranch.id,
        props.dealerBranch.name
      ),
    };
  }

  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    onHideModal: PropTypes.func.isRequired,
    dealerBranch: PropTypes.instanceOf(DealerBranch).isRequired,
    onExistingUserAuthorized: PropTypes.func.isRequired,
  };

  async componentDidUpdate(prevProps) {
    const { dealerBranch } = this.props;
    if (
      !prevProps.showModal &&
      this.props.showModal &&
      !this.state.hasBeenLoaded
    ) {
      this.setState({
        dealerUsers: await dealerUserService.search(
          new DealerUserFilter({ dealerGroupId: dealerBranch.dealerGroupId })
        ),
        permissions: await await dealerUserService.getAllPermissions(),
        hasBeenLoaded: true,
      });
    } else if (prevProps.showModal && !this.props.showModal) {
      this.setState({
        selectedDealerUserId: null,
        dealerBranchSetting: new DealerBranchSetting(
          dealerBranch.id,
          dealerBranch.name
        ),
        submitting: false,
      });
    }
  }

  async save() {
    this.setState({ showValidations: true }, () => {
      if (this.validableRef.current.isValid()) {
        this.setState({ submitting: true });
        const { selectedDealerUserId, dealerBranchSetting } = this.state;
        dealerUserService
          .authorizeUser(selectedDealerUserId, dealerBranchSetting)
          .then((authorizedUser) => {
            this.props.onExistingUserAuthorized(authorizedUser);
          })
          .catch(() => this.setState({ submitting: false }));
      }
    });
  }

  render() {
    const { showModal, onHideModal } = this.props;
    const {
      dealerUsers,
      permissions,
      selectedDealerUserId,
      dealerBranchSetting,
      submitting,
      hasBeenLoaded,
      showValidations,
    } = this.state;
    return (
      <Modal
        show={showModal}
        showCancel={true}
        size="lg"
        title="Authorize Existing Dealer User"
        submitting={submitting}
        onShowUpdated={(showModal) => {
          if (!showModal) onHideModal();
        }}
        onOk={this.save}
        closeOnOk={false}
      >
        {!hasBeenLoaded && (
          <div className="container text-center mt-5 mb-5">
            <h4 className="mt-5 mb-2">Loading</h4>
            <Spinner show={true} size="fa-3x" />
          </div>
        )}
        {hasBeenLoaded && (
          <ValidableExistingUserFormData
            ref={this.validableRef}
            showValidations={showValidations}
            dealerUsers={dealerUsers}
            permissions={permissions}
            selectedDealerUserId={selectedDealerUserId}
            dealerBranchSetting={dealerBranchSetting}
            dealerUserChanged={(selectedDealerUserId) =>
              this.setState({ selectedDealerUserId })
            }
            onDealerBranchSettingChange={(dealerBranchSetting) =>
              this.setState({ dealerBranchSetting })
            }
          />
        )}
      </Modal>
    );
  }
}
